var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show && _vm.menuCategories.length > 0
    ? _c("div", { staticClass: "search-box" }, [
        _c("div", { staticClass: "has-search autocomplete" }, [
          _c("div", {}, [
            _c("span", {
              staticClass: "fa form-control-feedback",
              class: [_vm.isLoading ? "fa-spinner" : "fa-search"],
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-nowrap" }, [
              _c(
                "div",
                {
                  staticClass: "autocomplete-input-group",
                  class: { "autocomplete-selected": _vm.value },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.query,
                        expression: "query",
                        modifiers: { trim: true },
                      },
                    ],
                    ref: "inputSearch",
                    staticClass: "form-control",
                    attrs: {
                      name: "search",
                      type: "search",
                      autocomplete: "one-time-code",
                      "aria-label": "query",
                      placeholder: _vm.menuPlaceholder,
                      disabled: _vm.disabled,
                    },
                    domProps: { value: _vm.query },
                    on: {
                      blur: [
                        _vm.blur,
                        function ($event) {
                          return _vm.$forceUpdate()
                        },
                      ],
                      focus: _vm.focus,
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.query = $event.target.value.trim()
                        },
                        _vm.onSearch,
                      ],
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "down", 40, $event.key, [
                              "Down",
                              "ArrowDown",
                            ])
                          )
                            return null
                          return _vm.keyDown.apply(null, arguments)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "up", 38, $event.key, [
                              "Up",
                              "ArrowUp",
                            ])
                          )
                            return null
                          return _vm.keyUp.apply(null, arguments)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.keyEnter.apply(null, arguments)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                          )
                            return null
                          return _vm.keyEnter.apply(null, arguments)
                        },
                      ],
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm.query
                ? _c(
                    "div",
                    { staticClass: "input-group-append position-relative" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-default text-right min-w-auto px-2 py-0 d-flex align-items-center justify-content-center",
                          attrs: { type: "button" },
                          on: { click: _vm.clearSearchQuery },
                        },
                        [_vm._m(0)]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.menuCategories.length > 1
                ? _c(
                    "div",
                    { staticClass: "input-group-append position-relative" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-default dropdown-toggle text-right min-w-auto pl-2",
                          attrs: {
                            type: "button",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.menuLabel) +
                              "\n                        "
                          ),
                          _c("span", { staticClass: "pl-2" }, [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "rotate-icon right svg-inline--fa fa-angle-down fa-w-12 fa-1x",
                                attrs: {
                                  "aria-hidden": "true",
                                  focusable: "false",
                                  "data-prefix": "fas",
                                  "data-icon": "angle-down",
                                  role: "img",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 256 512",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "currentColor",
                                    d: "M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu" },
                        [
                          _vm._l(_vm.menuCategories, function (item, idx) {
                            return [
                              _c(
                                "a",
                                {
                                  key: `item-${idx}`,
                                  staticClass: "dropdown-item",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.setCategory(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t(item.name)) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMenu,
                  expression: "showMenu",
                },
              ],
              staticClass: "autocomplete-list",
            },
            [
              _c(
                "div",
                { staticClass: "autocomplete-list-items" },
                [
                  _vm._l(_vm.internalItems, function (item, i) {
                    return [
                      _c(
                        "div",
                        {
                          key: `group-${i}`,
                          staticClass: "autocomplete-list-element",
                        },
                        [
                          item.__group
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "autocomplete-list-option autocomplete-list-group",
                                },
                                [_c("span", [_vm._v(_vm._s(item.__group))])]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          key: `element-${i}`,
                          staticClass: "autocomplete-list-element",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "autocomplete-list-option autocomplete-list-item",
                              class: {
                                "autocomplete-item-active":
                                  i === _vm.arrowCounter,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onClickItem(item)
                                },
                                mouseover: function ($event) {
                                  _vm.arrowCounter = i
                                },
                              },
                            },
                            [
                              _vm._t(
                                "item",
                                function () {
                                  return [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.highlight(_vm.getItemList(item))
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    item.__subLabel
                                      ? _c(
                                          "span",
                                          { staticClass: "sublabel" },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.__subLabel)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                                { item: item }
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "d-flex align-items-center justify-content-center" },
      [
        _c("i", {
          staticClass: "fas fa-times-circle",
          staticStyle: { "font-size": "1.1rem" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }